import { type ValidParam, type ValidPrefix } from './types';

export const ROVO_PARAM_PREFIX: ValidPrefix = 'rovoChat';
export const ROVO_VALID_PARAMS: ValidParam[] = [
	'pathway',
	'agentId',
	'conversationId',
	'prompt',
	'cloudId',
	'triggerOpen',
	'insertPrompt',
	'stagingAreaOpen',
	'messageIdSelectedForPreview',
	'invocationIdSelectedForPreview',
	'promptLibraryOpen',
	'openChatMode',
];
